import { http } from "./http";
import { notificationsService } from "./notifications-service";
import { authService } from "@/services/auth-service";
import type { InvitationDTO } from "@/models/dtos/invitation-dto";
import type { UserDTO } from "@/models/dtos/user-dto";
import type { EntraUserDTO } from "@/models/dtos/entra-user-dto.ts";

class InvitationService {
  async getPendingInvitations() {
    const authHeader = await authService.getAuthHeader();
    return http
      .url("/invitations")
      .auth(authHeader)
      .get()
      .fetchError((err) => notificationsService.error(err))
      .json<InvitationDTO[]>();
  }

  async inviteUser(request: InvitationDTO): Promise<UserDTO> {
    const authHeader = await authService.getAuthHeader();
    const accessToken = await authService.getAccessToken();
    return http
      .url("/invitations/invite")
      .headers({
        "MS-Graph-Token": accessToken, // For Microsoft Graph API calls
      })
      .auth(authHeader)
      .post(request)
      .fetchError((err) => notificationsService.error(err))
      .json<UserDTO>();
  }

  async reinviteUser(request: EntraUserDTO) {
    const authHeader = await authService.getAuthHeader();
    const accessToken = await authService.getAccessToken();
    return http
      .url("/invitations/reinvite")
      .headers({
        "MS-Graph-Token": accessToken, // For Microsoft Graph API calls
      })
      .auth(authHeader)
      .post(request)
      .fetchError((err) => notificationsService.error(err))
      .json<EntraUserDTO>();
  }
}

export const invitationService = new InvitationService();
